import script from "./CommonSelectCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonSelectCompany.vue?vue&type=script&setup=true&lang=js"

import "./CommonSelectCompany.vue?vue&type=style&index=0&id=1b52b665&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b52b665"]])

export default __exports__